import { render } from "./ButtonComponent.vue?vue&type=template&id=32a684fc&scoped=true"
const script = {}

import "./ButtonComponent.vue?vue&type=style&index=0&id=32a684fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a684fc"]])

export default __exports__